import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const IsBefore = ({ property, onChange, value }) => {  
  const PropertyComponent = resolveComponentForOperator(property.type ? property.type : 'DATE', 'IS_BEFORE')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        value={value}
        isOperator={true}
      />
    </div>
  )
}

export default IsBefore
